import React, { useRef } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function SkillGauge2() {
  const sgauges2 = [
    { sgid: 13, name: "HTML", percent: '100%' },
    { sgid: 14, name: "CSS", percent: '90%' },
    { sgid: 15, name: "JavaScript", percent: '85%' },
    { sgid: 16, name: "PHP", percent: '75%' },
    { sgid: 17, name: "TypeScript", percent: '25%' },
    { sgid: 18, name: "MySQL", percent: '80%' }, 
    { sgid: 19, name: "Liquid", percent: '75%' }, 
  ];

  const skill_gauge_ref2 = useRef();

  useGSAP(() => {
    // Scoped selection within the component scope
    const thumbs2 = gsap.utils.toArray('.skill_gauge2'); 

    ScrollTrigger.batch(thumbs2, {
      start: 'center center',
      once: true,
      onEnter: (batch) => {
        batch.forEach((section2) => {
          const tl_sg2 = gsap.timeline();
          const gauge_needle2 = section2.querySelector('.skill_gauge_needle2');
          const gauge_bar2 = section2.querySelectorAll('.skill_gauge_bar_bg2 path');
          const txtPercent2 = section2.querySelector(".skill_gauge_txt2");

          // Clean percentage string and derive half-circle rotation angle
          const tPercentClean2 = parseFloat(txtPercent2.textContent) || 0;
          const targetRotation2 = (tPercentClean2 / 100) * 180;

          // Counter object proxy for smooth numeric text counter animation
          const counter = { val: 0 };

          tl_sg2
            .to(counter, {
              val: tPercentClean2,
              duration: 1.5,
              ease: "power1.inOut",
              onUpdate: () => {
                txtPercent2.textContent = `${Math.round(counter.val)}%`;
              }
            })
            .to(gauge_needle2, {
              duration: 1,
              rotation: targetRotation2,
              transformOrigin: "113px 20px",
              ease: "power2.out"
            }, 0.4)
            .to(gauge_bar2, {
              duration: 1,
              rotation: targetRotation2,
              transformOrigin: "150px 150px",
              ease: "power2.out"
            }, 0.45);
        });
      }
    });
  }, { scope: skill_gauge_ref2 });

  return (
    <div className="skill_gauge_container" ref={skill_gauge_ref2}>
      {sgauges2.map((gauge2) => (
        <div className="skill_gauge2" key={gauge2.sgid}>
          <svg className="skill_gauge_cont" version="1.1" x="0px" y="0px" viewBox="0 0 300 172">
            <text 
              x="50%" 
              y="70%" 
              className="skill_gauge_txt2" 
              alignmentBaseline="middle" 
              textAnchor="middle"
            >
              {gauge2.percent}
            </text>
            <defs>
              <clipPath id={`xclipPath${gauge2.sgid}`}>
                <path d="M150,22c70.7,0,128,57.3,128,128h22C300,67.2,232.8,0,150,0S0,67.2,0,150h22C22,79.3,79.3,22,150,22z" />
              </clipPath>
            </defs>
            <g className="skill_gauge_indicator2">
              <path d="M150,22c70.7,0,128,57.3,128,128h22C300,67.2,232.8,0,150,0S0,67.2,0,150h22C22,79.3,79.3,22,150,22z" />
            </g>
            <g className="skill_gauge_bar_bg2" style={{ clipPath: `url(#xclipPath${gauge2.sgid})` }}> 
              <path d="M150,22c70.7,0,128,57.3,128,128h22C300,67.2,232.8,0,150,0S0,67.2,0,150h22C22,79.3,79.3,22,150,22z" />
            </g>
            <g className="skill_gauge_needle2">
              <path d="M133.1,139.4l-96.4,10.7l96.4,10.4c3.5,5.7,9.8,9.5,17,9.5c11,0,20-9,19.9-20.1c0-11-9-20-20.1-19.9C142.9,129.9,136.6,133.7,133.1,139.4z"/>
            </g>
          </svg>
          <div className="gauge-title">{gauge2.name}</div>
        </div>
      ))}
    </div>
  );
}